export default "__VITE_ASSET__CRWbg8Kh__"